<template>
    <!-- TODO: Convert hover state to "Learn more" card reveal action (we can use this explicitly on mobile and hide quoteCard) -->
    <v-hover>
        <template v-slot:default="{ hover }">
            <v-card max-width="430">

                <v-img
                    :alt="leader.fullName + ' self portrait'"
                    :src="leader.image"
                    width="100%"
                >
                
                <triangle-div
                    :corner="corner"
                    :borderLeft="corner === 'bottom-left' ? '0px solid transparent' : '180px solid transparent'"
                    :borderRight="corner === 'bottom-left' ? '180px solid transparent' : '0px solid transparent'"
                    width="100px"
                ></triangle-div>

                <v-icon v-show="!mediumScreen" class="tap-icon" x-large>
                    mdi-gesture-tap
                </v-icon>

                </v-img>

                <v-card-text>
                    <h2 class="text-h6 primary--text">
                        {{ leader.fullName }}
                    </h2>

                    {{ leader.title }}

                </v-card-text>

                <v-fade-transition>
                    <v-overlay
                        v-if="hover"
                        v-show="!mediumScreen"
                        absolute
                        color="#036358"
                        style="padding: 60px;"
                    >

                        <v-container style="font-weight: bold;">{{ leader.shortQuote || leader.quote }}</v-container>

                    </v-overlay>
                </v-fade-transition>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
import TriangleDiv from '../TriangleDiv.vue'

export default {
    components: {
      'triangle-div': TriangleDiv,
    },
    name: "LeadershipCard",
    props: {
        /**
         * An object containing quote, title, fullName, and image
         * properties
         */
        leader: {
            type: Object,
        },
        /**
         * The corner of the parent container the traingle
         * should reside in.
         * @values top-left, top-right, bottom-left, bottom-right
         */
        corner: {
            type: String,
            default: "bottom-right"
        },
        /**
         * A boolean value indicating whether or not the screen
         * size is medium or larger.
         */
        mediumScreen: Boolean
    },
    data: () => {
        return {
            reveal: false,
            quote: "",
        }
    }
}
</script>

<style scoped>
.tap-icon {
    position: absolute;
    bottom: 10px;
    right: 10px;
    color: white;
}
</style>
